import type { Scenario } from '@orgsim/shared';
import { ApiError, api } from './client';

export type ScenarioEntry = {
  id: string;
  name: string;
  mode: Scenario['mode'];
  published: boolean;
  updatedAt: number;
};
export type StoredScenario = ScenarioEntry & { document: Scenario };

const path = (id: string) => `/api/scenarios/${encodeURIComponent(id)}`;

export const listScenarios = () => api.get<ScenarioEntry[]>('/api/scenarios');
export const getScenario = (id: string) => api.get<StoredScenario>(path(id));
export const deleteScenario = (id: string) => api.del<void>(path(id));

// Update first, create on 404: the editor then needs no separate notion of "new", and a
// scenario that only exists locally (imported, or left over in the browser) lands on the
// server the first time an admin saves it.
export async function saveScenario(scenario: Scenario, published: boolean): Promise<void> {
  const body = { scenario, published };
  try {
    await api.put(path(scenario.id), body);
  } catch (e) {
    if (!(e instanceof ApiError && e.status === 404)) throw e;
    await api.post('/api/scenarios', body);
  }
}
